module.exports = __webpack_public_path__ + "img/jeidian_bg@2x.c61a91fd.png";